import "./style.scss"

const ShowFormError = ({ children, message, show = false, delay = 2000 }) => {
  let isShow = show ? 'form-error-message-show' : '';
  if (!show) {
    return null
  }
  return (
    <div className={`form-error-message-wrapper ${isShow}`}>
      <span className="triangle-border">
        <span className="triangle-inner" />
      </span>
      <span className="rs-form-error-message-inner">{message || children}</span>
    </div>
  )
}

// ShowFormError.propTypes = {}

export default ShowFormError
